module.exports = __webpack_public_path__ + "img/icon-lock.29378176.svg";